export default __webpack_public_path__ + "static/media/fi-br-dollar.8de01bb9.svg";